import { SET_VEHICLE, KEY_STORE } from './constants'

export default {
  [SET_VEHICLE]({ commit }, vehicle) {
    localStorage.setItem(KEY_STORE, vehicle)
    commit(SET_VEHICLE, vehicle)
  }
}
